import { configureStore } from "@reduxjs/toolkit"
import commonReducer from "../common/commonSlice"
import indicatorProfileSlice from "../components/indicatorProfileSlice"

export const store = configureStore({
  reducer: {
    common: commonReducer,
    indicatorProfile: indicatorProfileSlice,
  },
})
